import React, {MouseEvent, TouchEvent, useState} from "react";
import {ButtonBack, ButtonNext, CarouselProvider, Slide, Slider,} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import IconNext from "../../data/Icons/leon-inmobiliaria-icons-arrow-1-down.svg";
import {Dialog} from "@headlessui/react";
import Button from "../common/Button";
import CloseIcon from "../../data/Icons/leon-inmobiliaria-icons-close.svg";
import {default as NextImage} from "next/image";
import {ScreenNumber, useMediaQuery} from "../../hooks/useMediaQuery";
import {useTranslation} from "next-i18next";
import {ObjectInterfaceWithCity} from "../../interfaces/ObjectInterface";

interface VermietungsCarouselProps {
	images?: string[];
	object: ObjectInterfaceWithCity;
}

function VermietungsCarousel(props: VermietungsCarouselProps) {
	const {t} = useTranslation();
	let [isOpen, setIsOpen] = useState(false);
	const [clickedCarouselIndex, setClickedCarouselIndex] = useState(0);
	const {currentScreen, currentScreenAsNumber} = useMediaQuery();

	const [xPos, setXPos] = useState(0);

	const handleMouseDown = (e: MouseEvent<HTMLImageElement>) => {
		setXPos(e.pageX)
	}

	const handleMouseUp = (e: MouseEvent<HTMLImageElement>, index: number) => {
		setXPos(old => {
			if (Math.abs(old - e.pageX) < 10) {
				setIsOpen(true);
				setClickedCarouselIndex(index)
			}
			return e.pageX;
		})
	}

	const handleTouchStart = (e: TouchEvent<HTMLImageElement>) => {
		setXPos(e.touches[0].pageX)
	}
	const handleTouchEnd = (e: TouchEvent<HTMLImageElement>, index: number) => {
		setXPos(old => {
			if (Math.abs(old - e.changedTouches[0].pageX) < 10) {
				setIsOpen(true);
				setClickedCarouselIndex(index)
			}
			return e.changedTouches[0].pageX;
		})

	}

	let totalSlides = props.images?.length ?? 0;
	if(props.object.youtube_key){
		totalSlides++;
	}

	return (
		<div id="vermietungscarousel">
			<CarouselProvider
				// calculated from the width of the image (1440x960)
				naturalSlideWidth={300}
				naturalSlideHeight={200}
				totalSlides={totalSlides}
				visibleSlides={currentScreenAsNumber >= ScreenNumber.md ? 2.4 : 1}
				step={1}
				currentSlide={0}
			>
				<div className="relative">
					<Slider classNameTrayWrap="no-scrollbar slider-center w-full">
						{props.images?.map((imgUrl, idx) => {
							
							let youtubeComponent = null;
							let newIdx = idx;
							if(props.object.youtube_key && idx > 0){
								newIdx++;
								let videoSrc = "https://www.youtube.com/embed/" + props.object.youtube_key + "?rel=0&loop=1&autoplay=1&mute=1&controls=0";
								let youtubeUrl = "https://www.youtube.com/watch?v=" + props.object.youtube_key;

								if(idx == 1){
									youtubeComponent = (
										<Slide key={idx} index={idx} className="">
											<div className={"image-container h-full"}>
												<a
													href={youtubeUrl}
													target="_blank"
													rel="noopener noreferrer"
													className={
														"image-container h-full w-full flex justify-center items-center cursor-pointer"
													}
												>
													<iframe 
														src={videoSrc}
														title="Property video"
														className="h-full w-full pointer-events-none"
													></iframe>
												</a>
											</div>
										</Slide>
									);
								}
							}

							return (
								<>
									{youtubeComponent}
									<Slide key={newIdx} index={newIdx} className="">
										{/* <Image
										hasMasterSpinner={false}
										src={imgUrl}
										className="object-cover p-2 h-full w-full random"
										/> */}
										<div className={"image-container"}>
											<div
												className={
													"image-container h-full w-full flex justify-center items-center"
												}
											>

												<NextImage
													fill
													sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
													alt=""
													src={imgUrl}
													onMouseDown={handleMouseDown}
													onMouseUp={(e) => handleMouseUp(e, idx)}
													onTouchStart={handleTouchStart}
													onTouchEnd={(e) => handleTouchEnd(e, idx)}
													className="h-full w-full"
													style={{objectFit: "cover", cursor: "pointer"}}
												/>
											</div>
										</div>
									</Slide>
								</>
							);
						})}
					</Slider>
					<ButtonBack className="invisible md:visible  text-white absolute top-0 bottom-0 left-10 ">
						<img
							src="/images/icons/btn-prev.png"
							alt="Prev"
							className="w-10 h-10 opacity-90"
						/>
					</ButtonBack>
					<ButtonNext className="invisible md:visible text-white absolute top-0 bottom-0 right-20 ">
						<img
							src="/images/icons/btn-next.png"
							alt="Next"
							className="w-10 h-10 opacity-90"
						/>
					</ButtonNext>
					<div className="absolute left-0 right-0 mx-2 lg:m-0 xl:bottom-12 bottom-5 lg:right-20 md:right-5 flex flex-row justify-between lg:left-auto lg:flex-col gap-2 hidden">
						{props.object?.["360tour"] && (
							<div className="">
								<Button
									onClick={(e) => {
										e.preventDefault();
										e.stopPropagation();
										window.open(
											props.object?.["360tour"]
											//"https://kuula.co/share/collection/7Fzdx?logo=1&info=0&fs=1&vr=0&zoom=1&sd=1&thumbs=1"
										);
									}}
									border={false}
									text={t("components.immoCard.openVirtualTour")}
									transparent={false}
								/>
							</div>
						)}
						<Button
							bgColor="bg-white"
							onClick={() => setIsOpen(true)}
							text={t("components.vermietungsCarousel.zoomIn")}
							transparent={false}
							border={false}
						/>
					</div>
				</div>
			</CarouselProvider>

			<Dialog
				id="popovercarousel"
				open={isOpen}
				onClose={() => setIsOpen(false)}
				className=""
			>
				<div className="fixed inset-0 flex z-50 backdrop-blur-md bg-slate-100 bg-opacity-50 w-full">
					<Dialog.Panel className="w-full h-full overflow-hidden">
						<CarouselProvider
							naturalSlideWidth={300}
							naturalSlideHeight={236}
							isIntrinsicHeight
							totalSlides={props.images?.length ?? 0}
							visibleSlides={1}
							currentSlide={clickedCarouselIndex}
							infinite
							className="h-full"
						>
							<div className="h-full">
								<Slider
									className="h-full"
									onClick={() => setIsOpen(true)}
									classNameTray={"h-full "}
									classNameTrayWrap={"h-full "}
								>
									{props.images?.map((imgUrl, idx) => (
										<Slide key={idx} index={idx} className="h-full">
											<div
												className={
													"absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full md:p-10"
												}
											>
												<NextImage
													fill
													alt=""
													src={imgUrl}
													className="!relative object-contain"

												/>
											</div>
										</Slide>
									))}
								</Slider>
								<ButtonBack className="invisible md:visible  text-white absolute top-0 bottom-0 left-20">
									<IconNext className="md:w-16 rotate-90 [&>*]:!fill-black bg-gray-200 bg-opacity-50 rounded-full p-3"/>
								</ButtonBack>
								<ButtonNext className="invisible md:visible text-white absolute top-0 bottom-0 right-20">
									<IconNext className="md:w-16 -rotate-90 [&>*]:!fill-black bg-gray-200 bg-opacity-50 rounded-full p-3"/>
								</ButtonNext>
							</div>
						</CarouselProvider>
						<button
							className="absolute md:top-40 md:right-40 top-0 right-0 p-1 md:h-10 md:w-10 h-5 w-5 bg-gray-100 rounded-md shadow-md"
							onClick={() => setIsOpen(false)}
						>
							<CloseIcon className="[&>*]:!fill-black "/>
						</button>
					</Dialog.Panel>
				</div>
			</Dialog>
		</div>
	);
}

export default VermietungsCarousel;
